import { render, staticRenderFns } from "./Roof.vue?vue&type=template&id=8ce9d7ac&scoped=true"
import script from "./Roof.vue?vue&type=script&lang=js"
export * from "./Roof.vue?vue&type=script&lang=js"
import style0 from "./Roof.vue?vue&type=style&index=0&id=8ce9d7ac&prod&scoped=true&lang=scss"
import style1 from "./Roof.vue?vue&type=style&index=1&id=8ce9d7ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce9d7ac",
  null
  
)

export default component.exports